import {useEffect, useState} from "react";
import {Button, Modal, Typography} from "antd";
import {EnvironmentOutlined} from "@ant-design/icons";

const {Title, Paragraph} = Typography;

export default function LocationPermissionGuide({setAllowLocation}) {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const checkPermission = async () => {
            const isMobile = /Android|iPhone|iPad|iPod/i.test(
                navigator.userAgent
            );

            // if (!isMobile) return;

            try {
                const permission = await navigator.permissions.query({
                    name: "geolocation",
                });

                if (permission.state === "prompt") {
                    setVisible(true);
                }
            } catch {
                setVisible(true);
            }


        };

        checkPermission();
    }, []);


    const requestLocation = () => {
        navigator.geolocation.getCurrentPosition(
            (position) => {
                setAllowLocation?.(true)
                setVisible(false);
            },
            (error) => {

                if (error.code === 1) {
                    setAllowLocation?.(false)
                    setVisible(false);
                }
            }
        );
    };

    if (!visible) return null;

    return (
        <>

            <Modal
                title=""
                className={'max-w-md'}
                closable={{'aria-label': 'Custom Close Button'}}
                open={visible}
                onOk={() => {
                    setVisible(false);
                    requestLocation();
                }}
                onCancel={() => setVisible(false)}
                footer={<>

                </>}
            >
                {/*      <div className="absolute top-6 right-6 animate-bounce">*/}
                {/*          <div className="flex flex-col items-center text-white">*/}
                {/*              <span className="text-6xl">⬆️</span>*/}
                {/*              <span className="mt-2 text-sm font-medium">*/}
                {/*  روی پیام مرورگر کلیک کنید*/}
                {/*</span>*/}
                {/*          </div>*/}
                {/*      </div>*/}

                <div className="mb-4 flex justify-center">
                    <div className="flex h-16 w-16 items-center justify-center rounded-full bg-blue-100">
                        <EnvironmentOutlined className="text-3xl text-blue-600"/>
                    </div>
                </div>

                <Title level={3} className="!text-center">
                    دسترسی موقعیت مکانی
                </Title>

                <Paragraph className="!text-center !leading-8">
                    برای نمایش نقشه و تشخیص موقعیت شما، لطفاً در پیامی که نمایش داده خواهد شد
                    توسط مرورگر روی
                    <strong> Allow </strong>
                    یا
                    <strong> اجازه دادن </strong>
                    کلیک کنید.
                </Paragraph>

                <div className="mt-5 rounded-xl bg-gray-100 p-4 text-center text-sm text-gray-600">
                    در صورت رد کردن دسترسی، امکان نمایش موقعیت فعلی شما روی نقشه وجود
                    نخواهد داشت.
                </div>

                <Button
                    type="primary"
                    block
                    size="large"
                    className="mt-6"
                    onClick={() => {
                        setVisible(false)
                        requestLocation();
                    }
                    }
                >
                    متوجه شدم
                </Button>

            </Modal>

        </>
    );
}